import request from '~services/request';
export const SessionService = {
    create: (email, password) => request.post('/user/sessions', { email, password }).then(response => response.data),
    getOne: () => request.get('/user/sessions').then(response => response.data),
    getOAuth: () => request.get('/oauth/authorize').then(response => response.data)
};
